import React from 'react'
import HomeComponent from '../components/Home/Home'
import Services from '../components/Home/Services'
import FeatureProjects from '../components/Home/FeatureProjects'

const Home = () => {
  return(
    <>
    <HomeComponent/>
    <Services/>
    <FeatureProjects/>
    </>
  )
}

export default Home
